"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFilterDropdownMenu = void 0;
var react_1 = __importDefault(require("react"));
// https://react-bootstrap.github.io/components/dropdowns/#custom-dropdown-components
exports.AcFilterDropdownMenu = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, style = _a.style, className = _a.className, labeledBy = _a.labeledBy, show = _a.show, close = _a.close;
    return (react_1.default.createElement("div", { ref: ref, "x-placement": "bottom-end", style: style, className: className, "aria-labelledby": labeledBy }, react_1.default.Children.map(children, function (child) {
        var addedProps = { show: show, close: close };
        // @ts-ignore
        return react_1.default.cloneElement(child, addedProps);
    })));
});
exports.AcFilterDropdownMenu.displayName = 'AcFilterDropdownMenu';
//# sourceMappingURL=AcFilterDropdownMenu.js.map